import { render, staticRenderFns } from "./OtherWebsite.vue?vue&type=template&id=6adecf83&"
import script from "./OtherWebsite.vue?vue&type=script&lang=js&"
export * from "./OtherWebsite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports